<script setup lang="ts">
import PromoterProgressCard from '~/components/admin/PromoterProgressCard.vue'
import { dismissPromoterTask, promoterTasks } from '~/utils/promoterTask'
</script>

<template lang="pug">
//- Own fixed panel instead of sonner: stacked toasts overlap and shift on
//- hover. Sits above the Intercom launcher in the same corner.
ClientOnly
  Teleport(to="body")
    div(
      v-if="promoterTasks.length"
      class="pointer-events-none fixed bottom-40 right-4 z-[100] flex max-h-[calc(100vh-12rem)] flex-col items-end gap-2 overflow-y-auto"
      data-testid="promoter-progress-panel")
      PromoterProgressCard(
        v-for="task in promoterTasks"
        :key="task.id"
        class="pointer-events-auto"
        :state="task.state"
        :on-close="() => dismissPromoterTask(task.id)")
</template>
